<template>
	<app>
		<crumb-bar :current="detailInfo.project_name"></crumb-bar>
		<module>
			<flow-node :node="nodeList" :current="currentNode" :reject="rejectNode"></flow-node>
			<c-title>开工令详情</c-title>
			<c-detail>
				<c-detail-item label="项目名称" full>
					{{detailInfo.project_name}}
				</c-detail-item>
				<c-detail-item label="项目编号">
					{{detailInfo.project_code}}
				</c-detail-item>
				<c-detail-item label="监理单位">
					{{detailInfo.jldw_name}}
				</c-detail-item>
				<c-detail-item label="业主单位">
					{{detailInfo.yzdw_name}}
				</c-detail-item>
				<c-detail-item label="施工建设地址">
					{{detailInfo.xm_address}}
				</c-detail-item>
				<c-detail-item label="企业名称">
					{{detailInfo.zbqy_name}}
				</c-detail-item>
				<c-detail-item label="企业联系人">
					{{detailInfo.zbqy_fr_name}}<span v-if="detailInfo.zbqy_phone">（{{detailInfo.zbqy_phone}}）</span>
				</c-detail-item>
				<c-detail-item label="营业执照">
					<c-media :src="detailInfo.yyzz_path"></c-media>
				</c-detail-item>
				<c-detail-item label="法人身份证头像面">
					<c-media :src="detailInfo.frsfztx_path"></c-media>
				</c-detail-item>
				<c-detail-item label="资质证书">
					<c-media :src="detailInfo.zzzs_path"></c-media>
				</c-detail-item>
				<c-detail-item label="法人身份证国徽面">
					<c-media :src="detailInfo.frsfzgh_path"></c-media>
				</c-detail-item>
				<c-detail-item label="中标通知书">
					<c-file :src="detailInfo.zb_path"></c-file>
				</c-detail-item>
				<c-detail-item label="施工方案">
					<c-file :src="detailInfo.sgfa_path"></c-file>
				</c-detail-item>
				<c-detail-item label="备注说明">
					{{detailInfo.remark}}
				</c-detail-item>
				<c-detail-item label="其他文件">
					<c-file :src="detailInfo.other_path"></c-file>
				</c-detail-item>
			</c-detail>
			
			<c-title>项目关联保函</c-title>
			<project-insurance :project-id="detailInfo.project_id" :data="insuranceList"></project-insurance>
			
			<c-title>开工令</c-title>
			<c-table :value="proceedList" skin="detail">
				<c-table-column
					label="状态"
					width="80"
				>
					<template v-slot="{data}">
						<span v-if="proceedState[data.state]" :style="{'color': proceedState[data.state].color}">{{proceedState[data.state].name}}</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="文件路径"
					name="person"
					width="200"
				>
					<template v-slot="{data}">
						<c-file :src="data.kgl_path"></c-file>
					</template>
				</c-table-column>
				
				<c-table-column
					label="监理单位"
					name="jldw_name"
					width="200"
				></c-table-column>
				
				<c-table-column
					label="上传时间"
					name="jl_check_date"
					width="160"
				></c-table-column>
			</c-table>
			
			<c-title>审批流程</c-title>
			<c-detail>
				<c-detail-item label="审批记录" full>
					<timeline :data="timeline"></timeline>
				</c-detail-item>
			</c-detail>
			
			<c-button v-if="resubmitButton" slot="button" color="yellow" size="m" @click="navigateTo('/transact/proceed/edit', {id})">重新编辑</c-button>
			<div v-if="approveButton" slot="button" class="flex-center">
				<c-button color="green" size="m" width="300" @click="$refs.approve.resolve()">审批通过</c-button>
				<c-button color="red" size="m" @click="$refs.approve.reject()">驳回</c-button>
			</div>
		</module>
		
		<approve ref="approve" @resolve="approveHandle">
			<template v-slot="{state}">
				<c-form v-show="state">
					<c-form-item v-model="proceedFile" type="file" label="上传开工令" file-type="word,pdf,image" required></c-form-item>
				</c-form>
			</template>
		</approve>
	</app>
</template>

<script>
	import flowNode from '@/components/module/flow_node.vue'
	import projectInsurance from '@/pages/insurance/project_insurance.vue'
	import timeline from '@/components/module/timeline.vue'
	import approve from '@/components/module/approve.vue'
	import {mapGetters} from 'vuex'
	
	export default {
		components: {
			flowNode,
			projectInsurance,
			timeline,
			approve
		},
		
		props: {
			id: String
		},
		
		data() {
			return {
				nodeList: [{
					name: '提交申请'
				}, {
					name: '(监理方)审批'
				}, {
					name: '(业主方)审批'
				}, {
					name: '办理完结'
				}],
				detailInfo: {},
				insuranceList: [],
				proceedList: [],
				timeline: [],
				proceedFile: ''
			}
		},
		
		computed: {
			...mapGetters(['power', 'insuranceState', 'proceedState']),
			
			currentNode() {
				return this.detailInfo.state <= 3 ? this.detailInfo.state + 1 : 0;
			},
			
			rejectNode() {
				return this.detailInfo.state == 4 ? (this.detailInfo.reject_user_type == 8 ? 2 : 3) : 0;
			},
			
			resubmitButton() {
				return this.detailInfo.state == 4 && this.power('7');
			},
			
			approveButton() {
				return this.detailInfo.state == 1 && this.power('8');
			}
		},
		
		mounted() {
			this.updateDetail();
		},
		
		methods: {
			updateDetail() {
				this.request({
					url: '/project/kgl/detail',
					data: {
						kgl_id: this.id
					},
					success: data => {
						this.detailInfo = data.kglInfo;
						this.insuranceList = data.bx_list;
						this.proceedList = data.kgl_list;
						this.timeline = Array.from(data.logList, item => {
							return {
								date: item.create_date,
								content: `[${item.create_user_name}] ${item.remark}`
							}
						});
					}
				});
			},
			
			approveHandle(state, remark, stop, next) {
				stop();
				
				if (state && !this.proceedFile) {
					this.$message({
						text: '请上传开工令'
					});
					return;
				}
				
				this.request({
					url: '/project/kgl/updateStateJl',
					data: {
						kgl_id: this.id,
						state: state ? 2 : 4,
						kgl_path: this.proceedFile,
						jl_remark: remark
					},
					loading: true,
					success: data => {
						next();
						this.$message({
							text: '审批成功'
						});
						this.updateDetail();
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
